import React from 'react';
import PropTypes from 'prop-types';

import FeedbackMessageContainer from 'src/app/containers/FeedbackMessageContainer';
import TransclusionContainer from 'src/app/containers/TransclusionContainer';
import Logo from 'src/app/components/Logo';
import Footer from 'src/app/components/Footer';
import styles from 'src/app/components/Layout/LayoutLeftColumn.scss';


const LayoutLeftColumn = ({ children }) => (
  <div styleName="left-column">
    <FeedbackMessageContainer/>
    <TransclusionContainer/>

    <div styleName="left-column__logo">
      <Logo/>
    </div>

    <div styleName="left-column__content">
      {children}
    </div>

    <Footer customClass={ styles['left-column__footer'] } mobile/>
  </div>
);

LayoutLeftColumn.propTypes = {
  children: PropTypes.node.isRequired
};

export default LayoutLeftColumn;
